var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.91 42.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4cae4e;}.cls-2{fill:#424141;opacity:0.5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.46.55a12,12,0,0,0-12,12c0,6.63,10,18,12,29,2-11,12-22.37,12-29A12,12,0,0,0,12.46.55Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.46,
    cy: 11.55,
    r: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPin);
export default __webpack_public_path__ + "static/media/green_pin.8571aa00d1407b79713a0286bca66bbb.svg";
export { ForwardRef as ReactComponent };